import {
  TEMPLATE_TESTING_DATA_TYPES,
  TEMPLATE_TESTING_TEST_TYPES,
  TEMPLATE_TESTING_TABS,
  TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES,
} from '@/constants';

export default {
  filterByRuleType: 'Filtrer par type de règle',
  usePreFilledTemplate: 'Utiliser un modèle pré-rempli',
  usePreFilledTemplateWarning: 'La valeur actuelle sera perdue',
  headersHelpText: 'En-têtes pour la réponse HTTP',
  noHeadersAdded: 'Aucun en-tête ajouté pour le moment',
  formatJson: 'Formater JSON',
  outputPlaceholder: 'Les résultats du test apparaîtront ici...',
  runTest: 'EXÉCUTER LE TEST',
  notRun: 'Non exécuté',
  running: 'En cours',
  success: 'Succès',
  error: 'Erreur',
  testVariables: 'Studio Templates',
  testFailed: 'Le test a échoué',
  testName: 'Nom du test',
  testData: 'Données de test',
  addData: 'Ajouter des données',
  saveTest: 'Sauvegarder le test',
  saveTestAsNew: 'Sauvegarder comme nouveau test',
  errorsInInput: 'Erreur dans l\'entrée',
  mainFormHasErrors: 'Veuillez corriger les erreurs dans l\'onglet Général',
  isNewForm: 'Si vous sauvegardez ce test mais que le formulaire n’est pas enregistré, ce test sera supprimé à la fermeture de la fenêtre de création',
  testSaved: 'Test de modèle sauvegardé',
  testWillSaveAfterFormSaving: 'Le test de modèle sera sauvegardé après la validation du formulaire',
  lostCurrentTest: {
    text: 'Toutes les modifications non sauvegardées seront perdues pour le test actuel',
    actionText: 'Appliquer les nouvelles données de test',
    cancelText: 'Conserver les données de test précédentes',
  },
  requestUrl: 'URL de requête - {number}',
  requestPayload: 'Charge utile de requête - {number}',
  conditionValue: 'Valeur de condition',
  actionValue: 'Valeur d\'action - {number}',
  actionAuthor: 'Auteur d\'action - {number}',
  linkRuleLabel: 'Libellé de règle de lien - {number}',
  linkRuleUrl: 'URL de règle de lien - {number}',
  webhookUrl: 'URL webhook - {number}',
  webhookPayload: 'Charge utile webhook - {number}',
  webhookHeader: 'En-tête webhook {header} - {number}',
  noteOutput: 'Sortie (output) - {number}',
  widgetContent: 'Contenu du widget',
  widgetTemplate: 'Modèle de widget - {template}',
  columnTemplate: 'Modèle de colonne - {number}',
  ticketId: 'ID de ticket - {number}',
  ticketUrl: 'URL de ticket - {number}',
  ticketStatusWebhookUrl: 'URL webhook de vérification du statut - {number}',
  ticketStatusWebhookPayload: 'Charge utile webhook de vérification du statut - {number}',
  dynamicInfoValue: 'Valeur d\'information dynamique - {number} - {name}',
  instructionWebhookUrl: 'URL webhook de remédiation - Étape {step}, Opération {operation}',
  instructionWebhookPayload: 'Charge utile webhook de remédiation - Étape {step}, Opération {operation}',
  instructionWebhookHeader: 'En-tête webhook d\'instruction {header} - Étape {step}, Opération {operation}',
  instructionJobPayload: 'Charge utile de travail d\'instruction - {number}',
  operationDescription: 'Description de l\'opération - Étape {step}, Opération {operation}',
  jobPayload: 'Charge utile du job',
  jobQueryValue: 'QueryValue du job - {number}',
  metaAlarmOutputTemplate: 'Modèle de sortie de méta-alarme',
  metaAlarmComponentTemplate: 'Modèle de composant de méta-alarme',
  metaAlarmResourceTemplate: 'Modèle de ressource de méta-alarme',
  testVariablesDisabledTooltip: 'Le formulaire n\'a aucun champ de modèle',
  tabs: {
    [TEMPLATE_TESTING_TABS.data]: '@:templateTesting.testData',
    [TEMPLATE_TESTING_TABS.tests]: 'Tests',
  },
  dataTypes: {
    [TEMPLATE_TESTING_DATA_TYPES.event]: 'Événement',
    [TEMPLATE_TESTING_DATA_TYPES.response]: 'Réponse',
  },
  testTypes: {
    [TEMPLATE_TESTING_TEST_TYPES.eventFilter]: 'Filtre d\'événement',
    [TEMPLATE_TESTING_TEST_TYPES.linkRule]: 'Règle de lien',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Scénario d\'action',
    [TEMPLATE_TESTING_TEST_TYPES.widget]: 'Widget',
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Règle de déclaration de ticket',
    [TEMPLATE_TESTING_TEST_TYPES.dynamicInfo]: 'Information dynamique',
    [TEMPLATE_TESTING_TEST_TYPES.instruction]: 'Consigne',
    [TEMPLATE_TESTING_TEST_TYPES.job]: 'Travail',
    [TEMPLATE_TESTING_TEST_TYPES.metaAlarmRule]: 'Règle de méta-alarme',
  },
  templateVars: {
    ackAuthor: 'Auteur de l\'acquittement',
    ackAuthors: 'Auteurs de l\'acquittement',
    ackMessage: 'Message d\'acquittement',
    ackMessages: 'Messages d\'acquittement',
    actionInitiator: 'Initiateur de l\'action',
    alarm: 'Alarme',
    alarms: 'Alarmes',
    author: 'Auteur',
    childCount: 'Nombre d\'enfants',
    component: 'Composant',
    componentInfos: 'Infos du composant',
    components: 'Composants',
    connector: 'Connecteur',
    connectorName: 'Nom du connecteur',
    connectorNames: 'Noms des connecteurs',
    connectors: 'Connecteurs',
    consequenceAlarmEntities: 'Entités d\'alarmes conséquence',
    consequenceAlarms: 'Alarmes conséquence',
    displayName: 'Nom d\'affichage',
    displayNames: 'Noms d\'affichage',
    email: 'Email',
    entities: 'Entités',
    entity: 'Entité',
    event: 'Événement',
    externalData: 'Données externes',
    externalID: 'ID externe',
    externalSource: 'Source externe',
    extraInfos: 'Infos supplémentaires',
    firstname: 'Prénom',
    headerField: 'Champ d\'en-tête',
    headerFieldFromPreviousSteps: 'Champ d\'en-tête de l\'étape précédente',
    infos: 'Infos',
    initialOutput: 'Sortie initiale',
    initialOutputs: 'Sorties initiales',
    lastChildAlarm: 'Dernière alarme enfant',
    lastChildEntity: 'Dernière entité enfant',
    lastCommentAuthor: 'Auteur du dernier commentaire',
    lastCommentAuthors: 'Auteurs du dernier commentaire',
    lastCommentMessage: 'Message du dernier commentaire',
    lastCommentMessages: 'Messages du dernier commentaire',
    lastname: 'Nom de famille',
    name: 'Nom',
    names: 'Noms',
    numberOfAcknowledgedAlarms: 'Nombre d\'alarmes acquittées',
    numberOfAcknowledgedAlarmsUnderPbehavior: 'Nombre d\'alarmes acquittées sous pbehavior',
    numberOfActiveAlarms: 'Nombre d\'alarmes actives',
    numberOfAlarms: 'Nombre d\'alarmes',
    numberOfAlarmsInCriticalState: 'Nombre d\'alarmes en état Critique',
    numberOfAlarmsInMajorState: 'Nombre d\'alarmes en état Majeur',
    numberOfAlarmsInMinorState: 'Nombre d\'alarmes en état Mineur',
    numberOfAlarmsInOKState: 'Nombre d\'alarmes en état OK',
    numberOfAlarmsUnderPbehavior: 'Nombre d\'alarmes sous pbehavior',
    numberOfDependencies: 'Nombre de dépendances',
    numberOfNotAcknowledgedAlarms: 'Nombre d\'alarmes non acquittées',
    output: 'Sortie',
    outputs: 'Sorties',
    regexpMatch: 'Correspondance regexp',
    resource: 'Ressource',
    resources: 'Ressources',
    responseField: 'Champ de réponse',
    responseFieldFromStep: 'Champ de réponse de l\'étape',
    responseFieldFromPreviousSteps: 'Champ de réponse des étapes précédentes',
    responseFieldFromTheStepN: 'Champ de réponse de l\'étape #N',
    roleIDs: 'IDs de rôle',
    ruleID: 'ID de règle',
    ruleName: 'Nom de règle',
    stateMessage: 'Message d\'état',
    stateMessages: 'Messages d\'état',
    stateValue: 'Valeur d\'état',
    stateValues: 'Valeurs d\'état',
    statusValue: 'Valeur de statut',
    statusValues: 'Valeurs de statut',
    ticketAuthor: 'Auteur du ticket',
    ticketAuthors: 'Auteurs du ticket',
    ticketID: 'ID du ticket',
    ticketIDs: 'IDs des tickets',
    ticketMessage: 'Message du ticket',
    ticketMessages: 'Messages du ticket',
    trigger: 'Déclencheur',
    triggerEventMessage: 'Message d\'événement déclencheur',
    type: 'Type',
    types: 'Types',
    user: 'Utilisateur',
    userID: 'ID utilisateur',
    username: 'Nom d\'utilisateur',
    environmentVariables: 'Env',
    rawResponse: 'Réponse brute',
  },
  testDataLabels: {
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.event]: 'Événement',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.alarm]: 'Alarme',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.user]: 'Utilisateur',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.entity]: 'Entité',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.response]: 'Réponse',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.ticketStatusResponse]: 'Réponse de vérification du statut du ticket',
  },
  testDataResponseLabels: {
    [TEMPLATE_TESTING_TEST_TYPES.eventFilter]: 'Réponse (Données externes - {index} API)',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Réponse (Action - {index} webhook)',
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Réponse (Webhook - {index})',
  },
  testDataCheckTicketStatusResponseLabels: {
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Réponse de vérification du statut du ticket (Webhook - {index})',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Réponse de vérification du statut du ticket (Action - {index} webhook)',
  },
};
